<template>
  <div>
    <v-tabs :value="selectedTab"
            class="rounded-lg white--text"
            background-color="secondary"
            active-class="primary"
            color="#FF8700">
      <v-tab @click="changeRoute(tab)" v-for="tab in tabs" class="white--text mr-2">{{tab.title}}</v-tab>
    </v-tabs>
  </div>
</template>

<script>
export default {
  name: "TransactionTabs",
  data() {
    return {
    };
  },
  props: {
    type: {
      default: 'receive'
    },
  },
  mounted() {
  },
  computed: {
    selectedTab(){
      if(this.$route.name == 'TransactionForm' && this.type == 'receive') {
        return 0
      }
      if(this.$route.name == 'TransactionsList' && this.type == 'receive') {
        return 1
      }
      if(this.$route.name == 'TransactionForm' && this.type == 'payment') {
        return 0
      }
      if(this.$route.name == 'TransactionsList' && this.type == 'payment') {
        return 1
      }
      if(this.$route.name == 'BankingOperations' && this.type == 'bankTransfer') {
        return 2
      }
      if(this.$route.name == 'TransactionForm' && this.type == 'bankTransfer') {
        return 2
      }
      if(this.$route.name == 'TransactionsList' && this.type == 'bankTransfer') {
        return 3
      }

      if(this.$route.name == 'TransactionForm' && this.type == 'imprest') {
        return 0
      }
      if(this.$route.name == 'TransactionsList' && this.type == 'imprest') {
        return 1
      }
      if(this.$route.name == 'ImprestSettlementForm' && this.type == 'imprest') {
        return 2
      }
      if(this.$route.name == 'ImprestSettlementsList' && this.type == 'imprest') {
        return 3
      }
      if(this.$route.name == 'ImprestLedger' && this.type == 'imprest') {
        return 4
      }
      if(this.$route.name == 'ImprestBalance' && this.type == 'imprest') {
        return 5
      }

      if(this.$route.name == 'TransactionForm' && this.type == 'receivedGuarantee') {
        return 0
      }
      if(this.$route.name == 'TransactionsList' && this.type == 'receivedGuarantee') {
        return 1
      }

      if(this.$route.name == 'TransactionForm' && this.type == 'paymentGuarantee') {
        return 2
      }
      if(this.$route.name == 'TransactionsList' && this.type == 'paymentGuarantee') {
        return 3
      }
    },
    tabs() {
      if (this.type == 'imprest') {
        return [
          {title: 'پرداخت تنخواه', key: 'form', type: 'imprest'},
          {title: 'لیست پرداخت تنخواه', key: 'list', type: 'imprest'},
          {title: 'تسویه تنخواه', key: 'imprestSettlement', type: ''},
          {title: 'لیست تسویه تنخواه', key: 'imprestSettlementsList', type: ''},
          {title: 'گردش حساب تنخواه دار', key: 'imprestLedger', type: ''},
          //{title: 'صورت حساب کلی تنخواه', key: 'imprestBalance', type: ''},
        ]
      }
      if (this.type == 'receivedGuarantee' || this.type == 'paymentGuarantee') {
        return [
          {title: 'اسناد ضمانتی دریافتنی', key: 'form', type: 'receivedGuarantee'},
          {title: 'لیست اسناد ضمانتی دریافتنی', key: 'list', type: 'receivedGuarantee'},
          {title: 'اسناد ضمانتی پرداختنی', key: 'form', type: 'paymentGuarantee'},
          {title: 'لیست اسناد ضمانتی پرداختنی', key: 'list', type: 'paymentGuarantee'},

        ]
      }
      if (this.type == 'receive') {
        return [
          {title: 'ثبت دریافت', key: 'form', type: 'receive'},
          {title: 'لیست دریافت', key: 'list', type: 'receive'},
        ]
      }
      if (this.type == 'payment' || this.type == 'bankTransfer') {
        return [
          {title: 'ثبت پرداخت', key: 'form', type: 'payment'},
          {title: 'لیست پرداخت', key: 'list', type: 'payment'},
          {title: 'ثبت پرداخت بین بانکی', key: 'form', type: 'bankTransfer'},
          {title: 'لیست پرداخت بین بانکی', key: 'list', type: 'bankTransfer'},
        ]
      }
    },
  },
  methods: {
    changeRoute(tab){
      let keys = {
        list: '/report/lists/transactions/',
        form: '/panel/transaction/',
        defaultAccount: '/panel/defaultAccounts/',
        imprestSettlement: '/panel/imprestSettlement/',
        imprestSettlementsList: '/report/lists/imprestSettlements',
        imprestLedger: '/panel/imprest/ledger/',
        imprestBalance: '/panel/imprest/balance/'
      }
      this.$router.push(keys[tab.key] + tab.type)
    }
  }

  };
</script>

<style scoped lang="scss">
</style>

